import { ApiReportSectionsAiGeneratedStatusChoices, ReportSectionsType } from "@api/graphql/types-and-hooks";

export const isGeneratingSection = (sections: ReportSectionsType[]): boolean => {
  return sections.some(
    (section) => section.aiGeneratedStatus === ApiReportSectionsAiGeneratedStatusChoices.SectionPredictionPending,
  );
};

/**
 * The CentralReach learning-tree mapping is still filling the report's narrative fields. The server
 * only reports it for templates with reportNarrativeMappingWorkflow on, and only while IN_PROGRESS.
 */
export const isNarrativeMappingInProgress = (
  report?: { narrativeMappingInProgress?: boolean | null } | null,
): boolean => !!report?.narrativeMappingInProgress;

export const getSortedFieldsByRankOrder = (section: ReportSectionsType) => {
  const fields = section?.sectionField?.edges?.map((edge) => edge?.node)?.filter((node) => node != null) || [];
  fields.sort((a, b) => (a?.rankOrder ?? 0) - (b?.rankOrder ?? 0));
  return fields;
};

export const getNewFieldRankOrder = (section: ReportSectionsType): number => {
  const sortedFields = getSortedFieldsByRankOrder(section);
  const lastRankOrder = sortedFields[sortedFields.length - 1]?.rankOrder ?? 0;
  return lastRankOrder + 1;
};
